// Mirror of apps/api/src/unipile/utils/reply-subject.util.ts — keep the prefix
// regex in sync with the backend so the campaign editor displays exactly the
// subject the backend sends for a follow-up email. Reply/forward prefixes across
// common mail locales (EN Re/Fwd, DE AW/WG, NL Antw, SV/DA Sv/Vs, PL Odp).
const REPLY_PREFIX_REGEX = /^\s*(re|aw|antw|sv|odp|vs|fwd?|wg)\s*:/i;

/**
 * Builds the subject a follow-up email inherits from the previous email's
 * subject. Returns "" for an empty input, the subject untouched when it already
 * carries a reply/forward prefix, otherwise prepends "Re: ".
 */
export const buildReplySubject = (previousSubject: string): string => {
	const trimmed = previousSubject.trim();

	if (trimmed.length === 0) {
		return "";
	}

	return REPLY_PREFIX_REGEX.test(trimmed) ? trimmed : `Re: ${trimmed}`;
};
